import { FormHelperText, Label } from '@library/forms';
import { Form, Formik } from 'formik';
import CustomSwitch from 'modules/shared/components/FormFields/CustomSwitch';

import { ICamera } from '@api/models';
import useCameraPulginUpdate from 'modules/cameras/hooks/useCameraPluginUpdate';
import { toast } from 'react-toastify';
import { Button, CircularProgress } from '@hyperflake/react-ui-library';
import ErrorMessageInfo from '@components/ErrorMessageInfo/ErrorMessageInfo';

interface ICameraPulginFormProps {
    camera?: ICamera;
    clientId?: string;
    projectId?: string;
    onCameraUpdate?: (camera: ICamera) => void;
    isLoading?: boolean;
}

const CameraPluginForm = (props: ICameraPulginFormProps) => {
    const { camera, clientId, projectId, onCameraUpdate } = props;

    const updatePulginForm = useCameraPulginUpdate(camera, clientId, projectId);

    const handleSubmit = async (values: any) => {
        try {
            const data = await updatePulginForm.submit(values);
            onCameraUpdate(data);
            toast.success('Plugins Updated');
        } catch (ex: any) {
            toast.error(ex?.data?.message || 'Some error occured, please try again.');
            console.log(ex);
        }
    };

    return (
        <>
            <div>
                <div className="font-medium">AI</div>
                <Formik initialValues={updatePulginForm.initialValues} enableReinitialize onSubmit={handleSubmit}>
                    {({ values }) => (
                        <Form>
                            {/* Responsive container */}
                            <div
                                className="
                                    gap-6 mt-4 p-4
                                    md:flex-row md:items-center md:justify-between md:gap-10
                                "
                            >
                                {/* LEFT SECTION */}

                                <div className="w-full">
                                    {values.plugins.map((plugin, index) => (
                                        <div className="mt-2" key={index}>
                                            <CustomSwitch
                                                name={`plugins[${index}].isEnabled`}
                                                label={'Enable AI'}
                                                disabled={!camera?.location.latitude || !camera?.location.longitude}
                                            />
                                        </div>
                                    ))}

                                    {(!camera?.location.latitude || !camera?.location.longitude) && (
                                        <ErrorMessageInfo message="Add Latitude and Longitude first." />
                                    )}
                                </div>

                                {/* RIGHT SECTION (Save button) */}
                                <div className="w-full md:w-auto mt-4 ">
                                    <Button
                                        type="submit"
                                        size={'sm'}
                                        disabled={
                                            updatePulginForm.isSubmitting ||
                                            !camera?.location.latitude ||
                                            !camera?.location.longitude
                                        }
                                        className="w-full md:w-auto"
                                    >
                                        {updatePulginForm.isSubmitting ? (
                                            <CircularProgress color={'inherit'} size={18} />
                                        ) : (
                                            'Save'
                                        )}
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
};

export default CameraPluginForm;
